import _ from "lodash-es";

export default class Path {
  static join(...args: string[]) {
    args = args.map(function(v: string) {
      return _.trim(v, "/");
    });
    return _.join(args, "/");
  }
  static getParams(pathname: string) {
    const start = pathname.indexOf("?");
    const params = new Map<string, string>();
    if (start >= 0) {
      const queryString = pathname.slice(start + 1);
      const paramsArray = queryString.split("&");
      paramsArray.map(paramString => {
        const kv = paramString.split("=");
        const k = kv[0];
        let v = kv[1] ? kv[1] : "";
        v = decodeURIComponent(v);
        params.set(k, v);
      });
    }
    return params;
  }
  static setParam(pathname: string, key: string, value: string): string {
    const params = this.getParams(pathname);
    params.set(key, value);
    const paramsArray = new Array<string>();
    params.forEach((v, k) => {
      paramsArray.push(k + "=" + encodeURIComponent(v));
    });
    const queryString = paramsArray.join("&");
    const end = pathname.indexOf("?");
    if (end < 0) {
      pathname = pathname + "?" + queryString;
    } else {
      pathname = pathname.slice(0, end) + "?" + queryString;
    }
    return pathname;
  }
}
